import { push } from "connected-react-router";
import { AsyncAction } from "actions/types";

export function setPageAction(
  page: string, addToBreadCrumbTrail?: string, buttonText?: string
): AsyncAction {
  return (dispatch) => {
    dispatch(push(page, { addToBreadCrumbTrail, buttonText }));
  };
}

export const setPage = setPageAction;

export function goToPage(page: string): AsyncAction {
  return (dispatch) => {
    dispatch(push(page));
  };
}
